import { Decimal } from "decimal.js";

const UtilityPlugin = {
  install(Vue) {
    const nl2br = str => {
      var res = str.replace(/\r\n/g, "<br />");
      res = res.replace(/(\n|\r)/g, "<br />");
      return res;
    };
    Vue.filter("nl2br", nl2br);

    const checkAll = (e, variables, targetList, key, filter = null) => {
      // Initialize first
      variables.splice(0);

      if (e.target.checked) {
        if (filter !== null) {
          targetList = targetList.filter(filter);
        }

        targetList.forEach(row => {
          let val;

          if (Array.isArray(key)) {
            const temp = [];
            key.forEach(k => {
              temp.push(row[k]);
            });
            val = temp.join("-");
          } else {
            val = row[key];
          }

          if (!variables.some(v => v === val)) {
            variables.push(val);
          }
        });
      }
    };

    const compare = (a, b) => {
      // console.log(a, b);

      if (a === true) {
        a = 1;
      } else if (a === false) {
        a = 0;
      }

      if (b === true) {
        b = 1;
      } else if (b === false) {
        b = 0;
      }

      if (!a) {
        a = "";
      }
      if (!b) {
        b = "";
      }

      return a == b;
    };

    const convertSpace = str => {
      return (str || "").replace(/　/g, " ");
    };

    const decimal = str => {
      return new Decimal(str);
    };

    const reRegExp = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExp = new RegExp(reRegExp.source);
    const escapeRegExp = str => {
      return str && reHasRegExp.test(str) ? str.replace(reRegExp, "\\$&") : str;
    };

    const regExpMatch = (target, pattern) => {
      const escaped = escapeRegExp(pattern);
      return (target || "").match(new RegExp(escaped, "i"));
    };

    const judgeDateString = string => {
      return /^[0-9]{4}\/[0-9]{1,2}\/[0-9]{1,2}$/.test(string);
    };

    /**
     * スクロールバーの幅 (ピクセル単位) を取得する
     * Via: https://exiz.org/posts/javascript-scrollbar-width/
     */
    const getScrollbarWidth = () => {
      const element = document.createElement("div");
      element.style.visibility = "hidden";
      element.style.overflow = "scroll";
      element.textContent = "dummy";
      document.body.appendChild(element);
      const scrollbarWidth = element.offsetWidth - element.clientWidth;
      document.body.removeChild(element);

      return scrollbarWidth;
    };

    // Convert half Width
    const convert2HalfWidth = string => {
      return string.replace(/[！-～]/g, function(string) {
        return String.fromCharCode(string.charCodeAt(0) - 0xfee0);
      });
    };

    Vue.prototype.$utility = {
      checkAll,
      compare,
      convertSpace,
      decimal,
      getScrollbarWidth,
      escapeRegExp,
      regExpMatch,
      judgeDateString,
      convert2HalfWidth
    };
  }
};

export default UtilityPlugin;
